import { createContext, useEffect, useState } from "react";

export const DeanReportContentContext = createContext();

const initialReportContentState = {
  extensionOfNBAAccrediation: "",
  visitOfNBACommittee: "",
};

export const EXTENSION_OF_NBA_ACCREDIATION = "extensionOfNBAAccrediation";
export const VISIT_OF_NBA_COMMITTEE = "visitOfNBACommittee";

export const DeanReportContentContextProvider = ({ children }) => {
  const [content, setContent] = useState(initialReportContentState);

  const setSubTitle = (subTitle, subTitleContent) => {
    setContent((content) => {
      const newContent = {
        ...content,
      };
      newContent[subTitle] = subTitleContent;
      return newContent;
    });
  };

  const getSubTitle = (subTitle) => {
    return content[subTitle];
  };

  useEffect(() => {
    // Get the content from the backend and use setContent to set the same
    console.log(content);
  }, [content]);

  return (
    <DeanReportContentContext.Provider
      value={{ content, setContent, setSubTitle, getSubTitle }}
    >
      {children}
    </DeanReportContentContext.Provider>
  );
};
